import Vue from 'vue'
import store from '@/store'
import { checkHasPosition } from '@/utils/auth-directive'

Vue.prototype.$isEmpty = data => {
  switch (typeof data) {
    case 'array':
      return data.length === 0

    case 'object':
      return Object.keys(data).length === 0
  }

  return false
}

Vue.prototype.$isLoading = name => {
  return store.state.data.loading[name]
}

Vue.prototype.$nameMap = store.state.data.nameMap

Vue.prototype.$hasPermission = authority => {
  if (store.state.user.level === 'ROOT') return true
  return store.state.user.permissions.indexOf(authority) !== -1
}

Vue.prototype.$baseUrl = process.env.BASE_URL

Vue.prototype.$isTechnician = () => {
  return checkHasPosition('TECHNICIAN_PO')
}
